import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { fetchFurtherDetails, FETCH_FURTHER_DETAILS} from "../../actions/student.action"

function* handleFetchFurtherDetails(action) {
  try {
    const { data : resData} = yield call(studentAPI.fetchFurtherDetails, action.payload);
    //extract the data here     
    yield put(fetchFurtherDetails.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(fetchFurtherDetails.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* fetchFurtherDetailsSaga() {
  yield takeLatest(FETCH_FURTHER_DETAILS.REQUEST, handleFetchFurtherDetails);
}

export default fetchFurtherDetailsSaga;
